/* Rareva: swipeable product-card image strip (mobile only, under 750px)
   + metal colour swatches and colour filter circles on product cards
   + card links pointed at the 7" variant for products with a Length option.

   Works on EVERY product card site-wide. Cards carry their images in
   data-rv-imgs (rendered by rv-card-metal.liquid / rv-card-metal-all.liquid)
   and build instantly; any other card resolves its handle from the card link
   and lazily fetches /products/{handle}.js when it scrolls into view.

   Metal dots (.rv-card-metal .rv-ms) swap the card in place to the sibling
   product named in data-rv-handle. If that handle 404s and data-rv-alt is
   present (the other 10k/10kt handle style), it retries with that before
   giving up; a "silver-" handle with no alt retries as "sterling-silver-".
   If nothing loads the card stays put and the previous dot is restored.

   Length (bracelets): snippets/price.liquid prices the card from the 7"
   variant and emits span.rv-seven[data-rv-seven=id]; linkCards() below puts
   ?variant=<id> on the card link so the product page is served on 7" and
   never has to reload. On a dot swap the same is done from the fetched JSON.

   On mobile the card's full-card invisible link overlay (.card__heading a:after)
   is removed, because it swallowed the first touch on the strip -- the iOS
   first-tap-is-hover pattern. Image taps are handled below; the title stays a
   normal link. Desktop is untouched. */
(function () {
  'use strict';

  if (window.__rvCardSwipe) return;
  window.__rvCardSwipe = true;

  var cache = {};
  var MOBILE = '(max-width: 749px)';

  function isMobile() { return window.matchMedia(MOBILE).matches; }

  /* Money. The shop format is "${{amount}}", but cards were rendering the raw
     "${{amount}}" after a metal swap, so every known placeholder is handled
     first, then ANY remaining {{...}} placeholder, and if the string still
     carries braces the amount is returned on its own. Never show a template. */
  function money(cents) {
    var f = window.rvMoneyFormat || '${{amount}}';
    var n = (Number(cents) || 0) / 100;
    var amt = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var nd = Math.round(n).toLocaleString('en-US');
    var out = String(f)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, nd)
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, nd)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, nd)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amt)
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, amt)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, amt)
      .replace(/\{\{\s*amount\s*\}\}/g, amt);

    if (out.indexOf('{{') > -1 || out.indexOf('}}') > -1) {
      out = out.replace(/\{\{[\s\S]*?\}\}/g, amt);
    }
    if (out.indexOf('{{') > -1 || out.indexOf('}}') > -1 || out.indexOf(amt) === -1) {
      out = '$' + amt;
    }
    return out;
  }

  function sized(u, w) {
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function load(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      });
      cache[handle].catch(function () { delete cache[handle]; });
    }
    return cache[handle];
  }

  function injectCss() {
    if (document.getElementById('rv-swipe-css')) return;
    var s = document.createElement('style');
    s.id = 'rv-swipe-css';
    s.textContent = [
      '@media screen and (max-width: 749px){',
      '.card__inner{z-index:5 !important;}',
      '.card__inner .card__media{z-index:5 !important;}',
      '.card > .card__content{z-index:1 !important;position:relative;}',
      '.card__content .card__heading a:after{display:none !important;}',
      '.card__inner .card__content{pointer-events:none !important;}',
      '.card__media .media{pointer-events:none !important;}',
      '.card-wrapper:hover .media--hover-effect img:first-child{opacity:1 !important;}',
      '.rv-swipe{position:absolute;top:0;right:0;bottom:0;left:0;z-index:8;display:flex;flex-wrap:nowrap;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;scrollbar-width:none;-ms-overflow-style:none;touch-action:pan-x pan-y;}',
      '.rv-swipe::-webkit-scrollbar{display:none;}',
      '.rv-swipe__slide{flex:0 0 100%;width:100%;height:100%;scroll-snap-align:center;display:flex;align-items:center;justify-content:center;background:#fff;}',
      '.rv-swipe__slide img{width:100%;height:100%;object-fit:contain;display:block;pointer-events:none;}',
      '.rv-swipe__dots{position:absolute;left:0;right:0;bottom:8px;z-index:9;display:flex;justify-content:center;gap:5px;pointer-events:none;}',
      '.rv-swipe__dots span{width:5px;height:5px;border-radius:50%;background:#c9ced4;transition:background .2s;}',
      '.rv-swipe__dots span.on{background:#657898;}',
      '}'
    ].join('');
    document.head.appendChild(s);
  }

  function buildSwipe(card, urls, handle) {
    if (!isMobile()) return;
    urls = (urls || []).map(function (u) { return (u || '').trim(); }).filter(Boolean);
    if (urls.length < 2) return;
    var host = card.querySelector('.card__media');
    if (!host) return;
    injectCss();

    var prev = host.querySelectorAll('.rv-swipe, .rv-swipe__dots');
    for (var p = 0; p < prev.length; p++) { prev[p].parentNode.removeChild(prev[p]); }

    var baseImg = host.querySelector('.media img');
    var eagerFirst = !!baseImg && baseImg.getAttribute('loading') !== 'lazy';

    var strip = document.createElement('div');
    strip.className = 'rv-swipe';
    strip.setAttribute('data-rv-handle', handle || '');

    urls.forEach(function (u, i) {
      var slide = document.createElement('div');
      slide.className = 'rv-swipe__slide';
      var im = document.createElement('img');
      im.alt = '';
      /* Speed: the first slide is downloaded up front, lazily unless the card's
         own image is one of the eager ones at the top of the page. The SECOND
         slide is downloaded as soon as the card scrolls near the viewport (see
         warmSecond below), so the first swipe never lands on a blank slide.
         Slides 3 and 4 are downloaded when the shopper first touches the strip. */
      im.setAttribute('loading', i === 0 && eagerFirst ? 'eager' : 'lazy');
      if (i === 1) { im.setAttribute('decoding', 'async'); }
      if (i === 0) { im.src = u; } else { im.setAttribute('data-rv-src', u); }
      slide.appendChild(im);
      strip.appendChild(slide);
    });

    var dots = document.createElement('div');
    dots.className = 'rv-swipe__dots';
    urls.forEach(function (_, i) {
      var d = document.createElement('span');
      if (i === 0) d.className = 'on';
      dots.appendChild(d);
    });

    function fillSlides() {
      var pend = strip.querySelectorAll('img[data-rv-src]');
      for (var k = 0; k < pend.length; k++) {
        pend[k].src = pend[k].getAttribute('data-rv-src');
        pend[k].removeAttribute('data-rv-src');
      }
      strip.removeEventListener('touchstart', fillSlides);
      strip.removeEventListener('pointerdown', fillSlides);
    }
    strip.addEventListener('touchstart', fillSlides, { passive: true });
    strip.addEventListener('pointerdown', fillSlides, { passive: true });

    strip.addEventListener('scroll', function () {
      fillSlides();
      strip.rvLastScroll = Date.now();
      var w = strip.clientWidth || 1;
      var idx = Math.round(strip.scrollLeft / w);
      var ds = dots.querySelectorAll('span');
      for (var j = 0; j < ds.length; j++) { ds[j].className = j === idx ? 'on' : ''; }
    }, { passive: true });

    /* Pre-download slide 2 only (slides 3-4 still wait for the first touch). */
    function fillSecond() {
      var second = strip.querySelector('img[data-rv-src]');
      if (!second) return;
      second.src = second.getAttribute('data-rv-src');
      second.removeAttribute('data-rv-src');
    }

    host.appendChild(strip);
    host.appendChild(dots);
    warmSecond(strip, fillSecond);
  }

  /* Fires fillSecond for a strip once it comes within 200px of the viewport,
     so slide 2 is already in the browser cache before the shopper swipes. */
  var warmIo = null;
  function warmSecond(strip, cb) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    if (!warmIo) {
      warmIo = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            warmIo.unobserve(entries[i].target);
            var fn = entries[i].target.rvWarm;
            if (fn) fn();
          }
        }
      }, { rootMargin: '200px 0px' });
    }
    strip.rvWarm = cb;
    warmIo.observe(strip);
  }

  function cardHandle(card) {
    var a = card.querySelector('.card__heading a[href*="/products/"]');
    if (!a) return null;
    var href = a.getAttribute('href') || '';
    var parts = href.split('/products/');
    if (parts.length < 2) return null;
    var h = parts[1].split('?')[0].split('#')[0].split('/')[0];
    return h || null;
  }

  /* Card link -> the card's own product URL (already carrying ?variant= if set). */
  function cardHref(card) {
    var a = card.querySelector('.card__heading a[href*="/products/"]');
    return a ? a.getAttribute('href') : null;
  }

  /* Put ?variant=<7" id> on card links for Length products. */
  function linkCards(root) {
    var marks = (root || document).querySelectorAll('.product-card-wrapper .rv-seven[data-rv-seven]');
    for (var i = 0; i < marks.length; i++) {
      var id = marks[i].getAttribute('data-rv-seven');
      var card = marks[i].closest('.product-card-wrapper');
      if (!id || !card) continue;
      var links = card.querySelectorAll('.card__heading a[href*="/products/"]');
      for (var j = 0; j < links.length; j++) {
        var href = links[j].getAttribute('href') || '';
        if (href.indexOf('variant=') > -1) continue;
        var base = href.split('?')[0].split('#')[0];
        links[j].setAttribute('href', base + '?variant=' + id);
      }
    }
  }

  function hydrate(card) {
    var h = cardHandle(card);
    if (!h) return;
    load(h)
      .then(function (p) {
        buildSwipe(card, (p.images || []).slice(0, 4).map(function (u) { return sized(u, 533); }), h);
      })
      .catch(function () {});
  }

  var io = null;
  function observe(card) {
    if (!('IntersectionObserver' in window)) { hydrate(card); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            io.unobserve(entries[i].target);
            hydrate(entries[i].target);
          }
        }
      }, { rootMargin: '300px 0px' });
    }
    io.observe(card);
  }

  function initCards(root) {
    if (!isMobile()) return;
    var wraps = (root || document).querySelectorAll('.product-card-wrapper');
    for (var i = 0; i < wraps.length; i++) {
      var w = wraps[i];
      if (w.getAttribute('data-rv-swipe') === '1') continue;
      if (!w.querySelector('.card__media')) continue;
      w.setAttribute('data-rv-swipe', '1');
      var el = w.querySelector('.rv-card-metal[data-rv-imgs]');
      var attr = el ? (el.getAttribute('data-rv-imgs') || '') : '';
      if (attr.replace(/\|/g, '').trim()) {
        buildSwipe(w, attr.split('|'), el.getAttribute('data-rv-handle'));
      } else {
        observe(w);
      }
    }
  }

  function hasLength(p) {
    return (p.options || []).some(function (o) {
      var n = typeof o === 'string' ? o : (o && o.name) || '';
      return n === 'Length';
    });
  }

  /* Pick the variant the card should price from. Bracelets carry a Length
     option and the card shows the 7" price (see snippets/price.liquid). */
  function priceVariant(p) {
    var vs = p.variants || [];
    if (!vs.length) return null;
    if (hasLength(p)) {
      for (var i = 0; i < vs.length; i++) {
        var t = (vs[i].title || '') + ' ' + (vs[i].option2 || '') + ' ' + (vs[i].option1 || '');
        if (t.indexOf('7"') > -1 && vs[i].available !== false) return vs[i];
      }
    }
    return vs[0];
  }

  function apply(card, p, handle) {
    var v = priceVariant(p);
    var url = '/products/' + handle + (v && hasLength(p) ? '?variant=' + v.id : '');

    card.querySelectorAll('.card__heading a').forEach(function (a) {
      a.href = url;
      a.textContent = p.title;
    });

    /* 28 Oct 2026: the new first image is downloaded before it replaces the
       visible one, so the card never flashes blank during a metal swap. */
    var imgs = card.querySelectorAll('.card__media img');
    function swapImgs() {
      if (imgs[0] && p.images && p.images[0]) {
        imgs[0].src = sized(p.images[0], 533);
        imgs[0].removeAttribute('srcset');
        imgs[0].alt = p.title;
      }
      if (imgs[1] && p.images && p.images[1]) {
        imgs[1].src = sized(p.images[1], 533);
        imgs[1].removeAttribute('srcset');
        imgs[1].alt = p.title;
      }
    }
    if (imgs[0] && p.images && p.images[0]) {
      var pre = new Image();
      pre.onload = pre.onerror = function () { pre.onload = pre.onerror = null; swapImgs(); };
      pre.src = sized(p.images[0], 533);
    } else {
      swapImgs();
    }

    if (v) {
      var sale = card.querySelector('.price__sale .price-item--sale');
      var cmp = card.querySelector('.price__sale .price-item--regular');
      var reg = card.querySelector('.price__regular .price-item--regular');
      var cmp2 = card.querySelector('span.compare_at_price');
      var pct = card.querySelector('.rv-off__pct');
      if (sale) sale.textContent = money(v.price);
      if (cmp && v.compare_at_price) cmp.textContent = money(v.compare_at_price);
      if (reg) reg.textContent = money(v.price);
      if (cmp2 && v.compare_at_price) cmp2.textContent = money(v.compare_at_price);
      if (pct && v.compare_at_price && v.compare_at_price > v.price) {
        pct.textContent = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% off';
      }
    }

    buildSwipe(card, (p.images || []).slice(0, 4).map(function (u) { return sized(u, 533); }), handle);
  }

  document.addEventListener('click', function (e) {
    var strip = e.target.closest('.rv-swipe');
    if (strip) {
      e.preventDefault();
      e.stopPropagation();
      if (Date.now() - (strip.rvLastScroll || 0) < 400) return;
      var sc = strip.closest('.product-card-wrapper');
      var go = sc ? cardHref(sc) : null;
      var sh = strip.getAttribute('data-rv-handle');
      if (go) window.location.href = go;
      else if (sh) window.location.href = '/products/' + sh;
      return;
    }

    var b = e.target.closest('.rv-card-metal .rv-ms');
    if (b) {
      e.preventDefault();
      e.stopPropagation();
      var card = b.closest('.product-card-wrapper');
      /* 28 Oct 2026: cards for "sterling-silver-" products build gold dot
         handles like "sterling-10kt-yellow-gold-xxx", which do not exist.
         Strip a leading "sterling-" unless it is "sterling-silver-". */
      function rvFix(h){ if(!h) return h; return h.replace(/^sterling-(?!silver-)/,''); }
      var handle = rvFix(b.getAttribute('data-rv-handle'));
      var alt = rvFix(b.getAttribute('data-rv-alt'));
      if (!card || !handle) return;
      /* 28 Oct 2026: Christmas silver pieces use "sterling-silver-" handles. */
      if (!alt && /^silver-/.test(handle)) alt = 'sterling-' + handle;
      var was = b.parentNode.querySelector('.rv-ms.active');
      b.parentNode.querySelectorAll('.rv-ms').forEach(function (x) { x.classList.remove('active'); });
      b.classList.add('active');
      /* If no sibling loads, stay on the page and restore the previous dot
         (never navigate to a product URL that failed: that was a 404 reload). */
      function revert() {
        b.classList.remove('active');
        if (was) was.classList.add('active');
      }
      load(handle)
        .then(function (pr) { apply(card, pr, handle); })
        .catch(function () {
          if (alt) {
            load(alt)
              .then(function (pr) { b.setAttribute('data-rv-handle', alt); apply(card, pr, alt); })
              .catch(revert);
          } else {
            revert();
          }
        });
      return;
    }

    var cf = e.target.closest('.rv-color-filter .rv-cf');
    if (cf) {
      e.preventDefault();
      e.stopPropagation();
      var href = cf.getAttribute('data-href');
      if (href) window.location.href = href;
    }
  }, true);

  var t = null;
  function scheduleInit() {
    if (t) clearTimeout(t);
    t = setTimeout(function () { linkCards(); initCards(); }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }
  if (window.MutationObserver) {
    new MutationObserver(scheduleInit).observe(document.documentElement, { childList: true, subtree: true });
  }
})();